import { Box, Typography } from '@mui/material';
import React, { Component } from 'react';

const ErrorMessage = ({ message }) => {
    return (
        <div style={{
            border: '1px solid red',
            borderRadius: '5px',
            padding: '10px',
            backgroundColor: '#ffe6e6',
            color: 'red'
        }}>
            {message}
        </div>
    );
};

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Здесь можно логировать ошибку, например, отправить на сервер
        console.error("Ошибка поймана в ErrorBoundary: ", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Можно отобразить запасной интерфейс
            return (
                <Box sx={{ margin: 5 }}>
                    <Typography variant='h5' >Ошибка. Для продолжения работы перезагрузите страницу</Typography>
                    <br />
                    Error message:<br /> <ErrorMessage message={this.state.error?.message} />
                    <br />
                    Error stack:<br /> <ErrorMessage message={this.state.error?.stack} />

                    <br/>
                    <br/>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo?.componentStack}
                    </details>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
